<template>
    <div class="g_header_right">
        <div class="right_header">
            <span>您好 管理员</span>
            <span @click="dialog = true">修改密码</span>
            <span class="back" @click="backAcount">退出</span>
        </div>

        <el-dialog title="修改密码" :visible.sync="dialog" width="30%">
            <div class="order_input1">
                <el-input v-model="password" clearable placeholder="输入旧密码"></el-input>
            </div>
            <div class="order_input1">
                <el-input v-model="newPassword" clearable placeholder="设置新密码"></el-input>
            </div>
            <div>
                <el-input v-model="showPsd" clearable placeholder="重复新密码"></el-input>
            </div>
            <span slot="footer" class="dialog_footer">
                <el-button type="primary" @click="sendApi">确定</el-button>
                <el-button @click="dialog = false">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
var util = require("@/common/util.js");
import { API_XIUGMMA } from "../assets/js/api";
export default {
    data () {
        return {
            dialog: false,
            password: '',
            newPassword: '',
            showPsd: ''
        }
    },
    methods: {
        backAcount(){
            this.$confirm("确定退出登录?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                localStorage.removeItem("token");
                this.$router.push({ path: "/" });
                this.$message({
                    showClose: true,
                    message: "操作成功",
                    type: "success",
                });
            }).catch(() => {
                console.log("已取消");
            });
        },
        sendApi(){
            if(this.password == '' || this.newPassword == '' || this.showPsd == ''){
                this.$message('请完善信息！')
                return
            }
            if(this.newPassword != this.showPsd){
                this.$message('两次密码不一致！')
                return
            }
            let params = new URLSearchParams();
            params.append('password', this.password);
            params.append('newPassword', this.newPassword);
            util.getData(API_XIUGMMA, params, (res) => {
                if(res.data.code == 0){
                    this.$message({
                        showClose: true,
                        message: '修改成功',
                        type: "success",
                    });
                    this.dialog = false
                }else{
                    this.$message(res.data.data)
                }
            })
        }
    }
}
</script>

<style lang="less">
.g_header_right {
    .right_header{
        background-color: #5c6be8;
        color: #fff;
        padding-right: 40px;
        height: 60px;
        line-height: 60px;
        text-align: right;
        span{
            cursor: pointer;
            margin-left: 14px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/opHead.vue